import { render, staticRenderFns } from "./CommonConfig.vue?vue&type=template&id=4a0f3e86"
import script from "./CommonConfig.vue?vue&type=script&lang=js"
export * from "./CommonConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports